import { ProgressWizard, findFormTracker } from "$lib/core/js/forms";

/** @type {WeakMap<HTMLFormElement, ProgressWizard>} */
const wizardMap = new WeakMap();

/**
 * @param {HTMLFormElement} form 
 */
export function addMultiStep(form) {

	// We are only doing this once when the page is loaded, so
	// this may need to be modified if we ever implement a live-updated, client-side form editor.
	
	// If this Baylor Form is doesn't have the requisite markup for a MultiStep form, don't set one up.
	const tracker = findFormTracker(form);
	const body = /** @type {HTMLElement} */ (form.querySelector(":scope .progress-body"));
	const progressActions = /** @type {HTMLInputElement[]} */ ([...form.querySelectorAll(`:scope :is(.edit-actions,.form-actions) :is(input[type="submit"], button)[data-progress-op]`)]);

	if (!tracker || !body || progressActions.length === 0) return;

	const wizard = new ProgressWizard({
		tracker,
		body,
		form,
	});

	wizardMap.set(form, wizard);

	wizard.init();
}

/**
 * @param {HTMLFormElement} form 
 * @returns {ProgressWizard|undefined}
 */
export function getProgressWizard(form) {
	return wizardMap.get(form);
}
